import React, { useState } from "react"
import { cn } from "../styles/utils"
import { type PropsWithClassname } from "../types"
import { Box } from "./Box"
import { Icon } from "./Icons"
import { Pressable } from "./Pressable"

interface TwoStepConfirmButtonProps extends PropsWithClassname {
  onConfirm: () => void
  initialContent: React.ReactNode
  confirmationContent: React.ReactNode
  initialClassName?: string
  confirmationClassName?: string
  tickClassName?: string
  crossClassName?: string
  disabled?: boolean
}

export const TwoStepConfirmButton: React.FC<TwoStepConfirmButtonProps> = ({
  onConfirm,
  initialContent,
  confirmationContent,
  initialClassName,
  confirmationClassName,
  tickClassName,
  crossClassName,
  disabled = false,
  className,
}) => {
  const [isConfirming, setIsConfirming] = useState(false)

  const handleInitialClick = () => {
    setIsConfirming(true)
  }

  const handleConfirm = () => {
    onConfirm()
    setIsConfirming(false)
  }

  const handleCancel = () => {
    setIsConfirming(false)
  }

  if (disabled) {
    return null
  }

  if (isConfirming) {
    return (
      <Box className={cn("flex flex-row items-center gap-1", className)}>
        <Box className={confirmationClassName}>{confirmationContent}</Box>
        <div className="flex flex-row items-center">
          <Pressable
            onPress={handleConfirm}
            className={cn(
              "p-1 rounded hover:bg-green-100 active:bg-green-200",
              tickClassName,
            )}
          >
            <Icon name="check-circle" className="h-4 w-4 text-green-600" />
          </Pressable>
          <Pressable
            onPress={handleCancel}
            className={cn(
              "p-1 rounded hover:bg-red-100 active:bg-red-200",
              crossClassName,
            )}
          >
            <Icon name="x-circle" className="h-4 w-4 text-red-600" />
          </Pressable>
        </div>
      </Box>
    )
  }

  return (
    <Pressable
      onPress={handleInitialClick}
      className={cn(
        "p-1 rounded hover:bg-red-100 active:bg-red-200 flex items-center justify-center",
        initialClassName,
        className,
      )}
    >
      {initialContent}
    </Pressable>
  )
}
